import { Icon } from 'semantic-ui-react';
import { formatCurrency } from '../services';

/**
 * Heart marker shown next to a Total Pay amount when part of the billable care behind it
 * comes from financial notes (same signal as the heart in the Financial Notes column).
 * Renders nothing when there is no billable-notes component.
 */
const NotesBillableHeart = ({ amount, scope = '' }) => {
    const value = parseFloat(amount);
    if (!value) return null;
    return (
        <Icon
            name="heartbeat"
            color="blue"
            className="ml-1"
            title={`Billable care from financial notes${scope ? ` (${scope})` : ''}: ${formatCurrency(value)}`}
        />
    );
};

export default NotesBillableHeart;
